<template src="@/templates/pdfEdu.html"></template>

<script>

  // import pdf from '@/assets/pdf/Department_of_Education_Translation_Form_School.pdf';

	export default {
		name: "pdfEdu",
    data() {
      return {
        parent_client_id: localStorage.getItem("parent_client_id")
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/pdfEdu.vue